<dx-data-grid #dataGrid id="gridContainer" [dataSource]="dataSource" (onToolbarPreparing)="onToolbarPreparing($event)"
  (onEditorPreparing)="onEditorPreparing($event)" (onCellPrepared)="onCellPrepared($event)">

  <!-- Definición de las columnas -->
  <!-- <dxo-selection mode="multiple" showCheckBoxesMode="always" caption="Seleccionar"></dxo-selection>
 -->
  <dxi-column dataField="id" caption="Id" [visible]="false"></dxi-column>
  <dxi-column dataField="title" caption="Nombre del documento"></dxi-column>
  <dxi-column dataField="customerName" caption="Empresa"> </dxi-column>
  <dxi-column dataField="containersNames" caption="Categoría" alignment="center" [allowFiltering]="true"></dxi-column>
  <dxi-column dataField="date" caption="Creación" alignment="center" [allowFiltering]="false"
    [allowHeaderFiltering]="false " dataType="date" format="dd/MM/yyyy" [sortOrder]="'desc'">
  </dxi-column>
  <dxi-column dataField="viewedAt" caption="Visto" alignment="center">
  </dxi-column>


  <dxi-column caption="Acciones" [allowFiltering]="false" [allowSorting]="false" alignment="center"
    cellTemplate="viewDoc"></dxi-column>

  <ng-container *dxTemplate="let data of 'viewDoc'">
    <button rel="tooltip" type="button" class="btn btn-action" (click)="onFileOpen(data.data.docData)">
      <i class="material-icons">remove_red_eye</i>
    </button>
    <button rel="tooltip" type="button" class="btn btn-danger btn-action" (click)="onDeleteRelation(data.data)">
      <i class="material-icons">close</i>
    </button>
  </ng-container>


  <!-- Añadir nuevos -->
  <!-- d-none No se ve, habría que editar listFormEditBase.ts -->
  <div *dxTemplate="let data of 'addNew'">

    <button class="btn btn-primary btn-sm btn-add" (click)="openNew()" *ngIf="dataSource">
      <i class="material-icons">add</i> <span class="d-none d-sm-inline-block">Nuevo</span></button>
 
  </div>


</dx-data-grid>

<div *ngIf="loadingA3Doc" class="custom-loading-container">
  <div class="custom-loading-message">
    <div class="loader"></div>
    <span>Conectando con A3Doc Cloud</span>
  </div>
</div>